import * as React from "react";
import PaginatedEntityTable from "components/common/PaginatedEntityTable";
import QueryHelper from "components/common/QueryHelper";
import usePluggableEntityTableElements from "hooks/usePluggableEntityTableElements";
import { Col } from "common/components";
import { useFetchEventProcedureSteps } from "security-app/hooks/useEventProceduresAPI";
import CurrentUser from "logic/users/CurrentUser";
import { useColumnRenderers } from "./column-renderers";
import { useListElements, useDeserializeEventProceduresSteps, entityActionRender } from "./constants";
import EventProcedureTabs from "../EventProcedureTabs";
function EventProcedureStepList() {
  const { columnRenderers } = useColumnRenderers();
  const listElements = useListElements();
  const deserializeEventProceduresSteps = useDeserializeEventProceduresSteps();
  const { eventProcedureStepsEntitiesKeyFn, searchEventProcedureSteps } = useFetchEventProcedureSteps(
    deserializeEventProceduresSteps
  );
  const { pluggableExpandedSections } = usePluggableEntityTableElements(
    null,
    "event_procedure_step"
  );
  const fetchEntities = (options) => {
    CurrentUser.reload();
    return searchEventProcedureSteps(options);
  };
  return /* @__PURE__ */ React.createElement(Col, { $align: "center" }, /* @__PURE__ */ React.createElement(
    PaginatedEntityTable,
    {
      humanName: "Event Procedure Steps",
      queryHelpComponent: /* @__PURE__ */ React.createElement(QueryHelper, { entityName: "Event Procedure Step" }),
      tableLayout: listElements.defaultLayout,
      fetchEntities,
      keyFn: eventProcedureStepsEntitiesKeyFn,
      entityActions: entityActionRender,
      entityAttributesAreCamelCase: false,
      columnRenderers,
      topRightCol: /* @__PURE__ */ React.createElement(EventProcedureTabs, { viewType: "steps" }),
      expandedSectionRenderers: pluggableExpandedSections
    }
  ));
}
export default EventProcedureStepList;
